import React, { Component } from 'react';
import { Input, Icon} from 'antd';
import ContentList from '../../basicElement/ContentList';

const IconStyle = {
    marginLeft: 10,
    verticalAlign: 'middle',
};

class MultiInput extends Component {
    state = {
        value: undefined
    }

    handleChange = (e) => {
        this.setState({ value: e.target.value });
    }

    handleClick = () => {
        const { list } = this.props;
        const { value } = this.state;
        const newList = [...(list || [])];
        newList.push(value);
        this.props.onChange(newList);
        this.setState({ value: undefined });
    }

    handleRemove = (index) => {
        const { list } = this.props;
        list.splice(index, 1);
        this.props.onChange(list);
    }

    render() {
        const { edit, list } = this.props;
        const { value } = this.state;
        return (
            <div>
                {
                    edit &&
                    <div style={{ marginBottom: 10 }}>
                        <Input maxLength="1000" value={value} placeholder={"请输入"} style={{ width: 240 }} onChange={this.handleChange} />
                        {
                            !value ?
                                <Icon type="plus-circle-o" style={{ ...IconStyle, cursor: 'no-drop' }} />
                            :
                                <Icon type="plus-circle-o" style={{ ...IconStyle, color: '#5750C9', cursor: 'pointer' }} onClick={this.handleClick} />
                        }
                    </div>
                }
                <ContentList
                    className="template"
                    data={list}
                    circle={true}
                    deteable={edit}
                    onRemove={(index) => this.handleRemove(index)}
                    render={item => item}
                />
            </div>
        );
    }
}

export default MultiInput;


// WEBPACK FOOTER //
// ./src/components/common/workFlowTemplate/MultiInput.js